import { render } from "./UserAutocomplete.vue?vue&type=template&id=ffa25a34&ts=true"
import script from "./UserAutocomplete.ts?vue&type=script&lang=ts"
export * from "./UserAutocomplete.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__